import React, { useContext, useRef } from "react"
// import { CanvasContext } from "../hooks/LessonPage"
// import "./VideoImageElement.scss"
import ReactHtmlParser from "react-html-parser"

const EmbedElement = props => {
  const { metadata, id, position, dimension, type } = props
  const elementRef = React.useRef(null)
  const [showGrids, setShowGrids] = React.useState(false)


  const renderElement = (type) =>
  {
    return(
          <>
            <div 
                ref={elementRef} 
                // dangerouslySetInnerHTML={{ __html: props.metadata.content }}                 
                 style={{ position : "absolute",  
                          pointerEvents :"auto",
                          left: position?.left || 0, 
                          top: position?.top || 0,
                          width: dimension?.width || 0, 
                          height: dimension?.height || 0,      
                          transform : dimension?.transform || "translate(1px, 1px)",                 
                          fontFamily: "Arial",
                          fontSize: "13px",
                          padding: 0,
                          float : "left",
                          border: `2px solid ${
                            showGrids 
                              ? "#21DEE5"
                              : "transparent"
                          }`,                            
                        }}>
             <div style={{ height: "100%", width: "100%", pointerEvents : props.readonly === true ? "none" : "" }}>
               {ReactHtmlParser(metadata.content || "")}
            </div>                      
         </div>   
            </>
    )     
  } 

  return (
    renderElement(type)
  )
}

export default EmbedElement
